import YoutubeVideoModel from '../../../../../../../models/youtube-sports/youtube-video/youtube-video.model';

export const constructYoutubeEmbedIframe = (video: YoutubeVideoModel) => {
	if (video && video.id) {
		return `<iframe width='100%' className='iframe' src='https://www.youtube.com/embed/${video.id.videoId}' title="${video.snippet.title}" allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope' frameBorder='0' allowFullScreen></iframe>`;
	}
	return '';
};
